import GenericDictionaryPage from "./GenericDictionaryPage";
import { getClaimCancelReason } from "../api/claimCancelReason";

export default function ClaimCancelReason() {
    return (
        <GenericDictionaryPage
            tableKey="claimCancelReason"
            fetchData={getClaimCancelReason}
            titleKey="genericDic:claimCancelReason"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:claimCancelReason").toLowerCase()
                })
            }
        />
    );
}
